import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { SERVICES_META } from '../data/mock';

const Card = ({ s, title, desc }) => {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current; if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    el.style.transform = `perspective(900px) rotateX(${(-y * 4).toFixed(2)}deg) rotateY(${(x * 5).toFixed(2)}deg) translateY(-2px)`;
  };
  const onLeave = () => {
    const el = ref.current; if (!el) return;
    el.style.transform = 'perspective(900px) rotateX(0) rotateY(0) translateY(0)';
  };
  const Icon = s.icon;
  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      data-testid={`service-card-${s.n}`}
      className="card-3d group relative p-7 md:p-8 bg-[#0B1C18] border border-white/5 rounded-2xl hover:border-[#5FE0C8]/40 hover:bg-[#0E2A24]"
    >
      <div className="flex items-start justify-between mb-8">
        <span className="text-[11px] tracking-[0.25em] uppercase text-[#7A7A7A]">{s.n}</span>
        <span className="w-9 h-9 rounded-full grid place-items-center bg-[#07120F] border border-white/10 group-hover:border-[#5FE0C8]/50 group-hover:bg-[#5FE0C8] transition-colors">
          <Icon className="w-4 h-4 text-[#5FE0C8] group-hover:text-[#07120F] transition-colors" strokeWidth={1.6} />
        </span>
      </div>
      <h3 className="font-display text-[22px] md:text-[24px] leading-tight text-[#ECE9DF] mb-3">{title}</h3>
      <p className="text-[14px] leading-relaxed text-[#9A9A8E]">{desc}</p>
    </div>
  );
};

const Services = () => {
  const { t } = useTranslation();
  const items = t('services.items', { returnObjects: true });
  return (
    <section id="services" className="relative py-28 md:py-36 bg-[#07120F]/80 backdrop-blur-sm">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-[640px]">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#5FE0C8] mb-5">{t('services.eyebrow')}</div>
            <h2 className="font-display text-[44px] md:text-[64px] leading-[0.98] tracking-tight">
              {t('services.heading1')}<br />
              <span className="font-serif-i text-[#5FE0C8]">{t('services.heading2a')}</span> {t('services.heading2b')}
            </h2>
          </div>
          <p className="max-w-[420px] text-[15px] text-[#9A9A8E] leading-relaxed">
            {t('services.intro')}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {SERVICES_META.map((s, i) => (
            <Card key={s.n} s={s} title={items[i]?.title} desc={items[i]?.desc} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
